import React, { useEffect, useRef, useState } from "react";
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import Step6 from "./step6";
import Step7 from "./step7";
import Step8 from "./step8";
import Step9 from "./step9";
import Step10 from "./step10";
import Step11 from "./step11";
import FinalStep from "./finalStep";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getAppearnace } from "../../../store/appearance/actions";

const CreateAi = () => {
  const dispatch = useDispatch();
  // const { openModal, closeModal } = useModal();
  const { APPEARANCELIST, loading } = useSelector((state) => state.Appearance);
  const appearanceList = APPEARANCELIST;
  const [step, setStep] = useState(1);
  const [gender, setGender] = useState();
  const [art, setArt] = useState();
  const [age, setAge] = useState("25");
  const [ethnicBackground, setEthnicBackground] = useState();
  const [height, setHeight] = useState(null);
  const [heightProgress, setHeightProgress] = useState(50);
  const [physique, setPhysique] = useState();
  const [boobs, setBoobs] = useState();
  const [butt, setButt] = useState();
  const [hairStyle, setHairStyle] = useState();
  const [hairColor, setHairColor] = useState();
  const [eye, setEye] = useState();
  const [sexOrientation, setSexOrientation] = useState();
  const [chatStyle, setChatStyle] = useState();
  const [voice, setVoice] = useState();
  const [occupation, setOccupation] = useState();
  const [relationship, setRelationship] = useState();
  const [kinks, setKinks] = useState();
  const [imageGenerated, setImageGenerated] = useState();
  const [personality, setPersonality] = useState();
  const [traits, setTraits] = useState({
    dominance: 50,
    confidence: 50,
    warmth: 50,
    sociability: 50,
    playfulness: 50,
  });

  const containerRef = useRef(null);
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [step]);

  const handleAppearance = () => {
    // const gender = localStorage.getItem("selected-gender");
    if (art && gender) {
      const callBack = (err, responce) => {
        if (err) {
          toast.error(err.message);
        } else {
          //setData(responce);
          console.log(responce, "teststs");
        }
      };
      const data = {
        gender,
        styleType: art,
      };
      dispatch(
        getAppearnace({
          data,
          callBack: callBack,
        }),
      );
    }
  };

  console.log(
    gender,
    art,
    age,
    ethnicBackground,
    height,
    physique,
    boobs,
    butt,
    sexOrientation,
    hairStyle,
    hairColor,
    eye,
    personality,
    chatStyle,
    voice,
    occupation,
    relationship,
    kinks,
    "asdf",
  );

  return (
    <>
      <section className="py-6 relative z-[9]">
        <div className="container">
          <div
            ref={containerRef}
            className="p-5 z-[99] relative overflow-x-hidden scrollbar-none bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.1)] border-[0.5px] rounded-[24px] h-[calc(100vh-120px)] overflow-auto scrollbar-none"
          >
            <div className="grid gap-4 grid-cols-12">
              {/* <button onClick={() => openModal("generate-loading-pop")}>
                click
              </button> */}
              <div className="col-span-12">
                {/* <StepNav step={step} setStep={setStep} /> */}
                {step == 1 ? (
                  <>
                    <Step1
                      gender={gender}
                      setGender={setGender}
                      art={art}
                      setArt={setArt}
                      step={step}
                      setStep={setStep}
                      onSubmit={handleAppearance}
                    />
                  </>
                ) : step == 2 ? (
                  <>
                    <Step6
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      sexOrientation={sexOrientation}
                      setSexOrientation={setSexOrientation}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 3 ? (
                  <>
                    <Step2
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      age={age}
                      setAge={setAge}
                      ethnicBackground={ethnicBackground}
                      setEthnicBackground={setEthnicBackground}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 4 ? (
                  <>
                    <Step3
                      gender={gender}
                      heightProgress={heightProgress}
                      setHeightProgress={setHeightProgress}
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      height={height}
                      setHeight={setHeight}
                      physique={physique}
                      setPhysique={setPhysique}
                      boobs={boobs}
                      setBoobs={setBoobs}
                      butt={butt}
                      setButt={setButt}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 5 ? (
                  <>
                    <Step4
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      hairStyle={hairStyle}
                      setHairStyle={setHairStyle}
                      hairColor={hairColor}
                      setHairColor={setHairColor}
                      eye={eye}
                      setEye={setEye}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 6 ? (
                  <>
                    <Step5
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      personality={personality}
                      setPersonality={setPersonality}
                      traits={traits}
                      setTraits={setTraits}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 7 ? (
                  <>
                    <Step7
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      voice={voice}
                      setVoice={setVoice}
                      chatStyle={chatStyle}
                      setChatStyle={setChatStyle}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 8 ? (
                  <>
                    <Step8
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      occupation={occupation}
                      setOccupation={setOccupation}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 9 ? (
                  <>
                    <Step9
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      relationship={relationship}
                      setRelationship={setRelationship}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 10 ? (
                  <>
                    <Step10
                      imageGenerated={imageGenerated}
                      setImageGenerated={setImageGenerated}
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      kinks={kinks}
                      setKinks={setKinks}
                      relationship={relationship}
                      occupation={occupation}
                      chatStyle={chatStyle}
                      sexOrientation={sexOrientation}
                      traits={traits}
                      personality={personality}
                      eye={eye}
                      hairColor={hairColor}
                      hairStyle={hairStyle}
                      butt={butt}
                      boobs={boobs}
                      physique={physique}
                      height={height}
                      ethnicBackground={ethnicBackground}
                      age={age}
                      art={art}
                      gender={gender}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == 11 ? (
                  <>
                    <Step11
                      imageGenerated={imageGenerated}
                      setImageGenerated={setImageGenerated}
                      appearanceList={appearanceList}
                      appearanceLoading={loading}
                      kinks={kinks}
                      relationship={relationship}
                      occupation={occupation}
                      chatStyle={chatStyle}
                      sexOrientation={sexOrientation}
                      traits={traits}
                      personality={personality}
                      eye={eye}
                      hairColor={hairColor}
                      hairStyle={hairStyle}
                      butt={butt}
                      boobs={boobs}
                      physique={physique}
                      height={height}
                      ethnicBackground={ethnicBackground}
                      age={age}
                      art={art}
                      gender={gender}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : step == "final" ? (
                  <>
                    <FinalStep
                      imageGenerated={imageGenerated}
                      step={step}
                      setStep={setStep}
                    />
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateAi;
